import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getSessionInfo, forceSessionRecovery, refreshGuestSession } from '../../utils/guestSessionUtils';

const GuestSessionDebug = ({ show = false }) => {
  const [sessionInfo, setSessionInfo] = useState(null);
  const [isRecovering, setIsRecovering] = useState(false);

  useEffect(() => {
    if (show) {
      updateSessionInfo();
    }
  }, [show]);

  const updateSessionInfo = () => {
    const info = getSessionInfo();
    setSessionInfo(info);
  };

  const handleForceRecovery = async () => {
    setIsRecovering(true);
    try {
      const recovered = await forceSessionRecovery();
      if (recovered) {
        toast.success('Session recovered successfully!');
      } else {
        toast.warn('No valid session found to recover');
      }
      updateSessionInfo();
    } catch (error) {
      toast.error('Failed to recover session');
    } finally {
      setIsRecovering(false);
    }
  };

  const handleRefreshSession = async () => {
    try {
      const refreshed = await refreshGuestSession();
      if (refreshed) {
        toast.success('Session refreshed successfully!');
        updateSessionInfo();
      }
    } catch (error) {
      toast.error('Failed to refresh session');
    }
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: '#f5f5f5',
      border: '1px solid #ccc',
      borderRadius: '5px',
      padding: '15px',
      maxWidth: '400px',
      fontSize: '12px',
      zIndex: 9999,
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}>
      <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Guest Session Debug</h4>
      
      {sessionInfo && (
        <div>
          <div><strong>Primary:</strong> {sessionInfo.primary ? sessionInfo.primary.substring(0, 20) + '...' : 'null'}</div>
          <div><strong>Backup:</strong> {sessionInfo.backup ? sessionInfo.backup.substring(0, 20) + '...' : 'null'}</div>
          <div><strong>Session:</strong> {sessionInfo.session ? sessionInfo.session.substring(0, 20) + '...' : 'null'}</div>
          <div><strong>Last Used:</strong> {sessionInfo.lastUsed || 'unknown'}</div>
          <div><strong>Valid:</strong> <span style={{ color: sessionInfo.isValid ? 'green' : 'red' }}>{sessionInfo.isValid ? 'Yes' : 'No'}</span></div>
        </div>
      )}
      
      <div style={{ marginTop: '10px' }}>
        <button 
          onClick={handleForceRecovery}
          disabled={isRecovering}
          style={{ marginRight: '5px', padding: '5px 10px', fontSize: '11px' }}
        >
          {isRecovering ? 'Recovering...' : 'Force Recovery'}
        </button>
        
        <button 
          onClick={handleRefreshSession}
          style={{ marginRight: '5px', padding: '5px 10px', fontSize: '11px' }}
        >
          Refresh
        </button>
        
        <button 
          onClick={updateSessionInfo}
          style={{ padding: '5px 10px', fontSize: '11px' }}
        >
          Update Info
        </button>
      </div>
      
      <div style={{ marginTop: '10px', fontSize: '10px', color: '#666' }}>
        <div>Press F12 to toggle this debug panel</div>
        <div>Use this to troubleshoot guest session issues</div>
      </div>
    </div>
  );
};

export default GuestSessionDebug;
